/* Decottaa teması – favoriler sayfası. */
(() => {
  const theme = window.theme || {};
  if (!theme.utils) return;
  const { $, parseHTML, readFavorites, syncFavorites } = theme.utils;

  class FavoritesList extends HTMLElement {
    connectedCallback() {
      this.grid = $('[data-favorites-grid]', this);
      this.empty = $('[data-favorites-empty]', this);
      this.render();
      this.onChange = () => this.render();
      document.addEventListener('favorites:change', this.onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('favorites:change', this.onChange);
    }

    async render() {
      const favorites = readFavorites();
      if (!favorites.length) {
        this.grid.replaceChildren();
        this.empty.hidden = false;
        return;
      }
      this.empty.hidden = true;
      const root = this.dataset.productsUrl || '/';
      const cards = await Promise.all(
        favorites.map(async (handle) => {
          try {
            const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=product-card-ajax`);
            if (!response.ok) return null;
            return $('.product-card', parseHTML(await response.text()));
          } catch (error) {
            return null;
          }
        })
      );
      const valid = cards.filter(Boolean);
      this.grid.replaceChildren(...valid);
      this.empty.hidden = valid.length > 0;
      syncFavorites(this);
    }
  }
  if (!customElements.get('favorites-list')) customElements.define('favorites-list', FavoritesList);
})();
